module.exports = __webpack_public_path__ + "img/user_placeholder.b47b22a.png";